import { Reveal } from "@/components/Reveal";

const STEPS = [
  { verb: "Recorded", line: "Knowledge is recorded.", note: "Archives preserve memory." },
  { verb: "Remembered", line: "Wisdom is remembered.", note: "Intelligence reveals relationships." },
  { verb: "Practiced", line: "Stewardship is practiced.", note: "People care for Country." },
];

// Recurring philosophy thread across the site.
export default function WisdomProgression({ dark = true }) {
  const text = dark ? "text-[#F4F1ED]" : "text-[#17130E]";
  const sub = dark ? "text-[#A8A5A1]" : "text-[#4A443B]";
  const line = dark ? "bg-white/10" : "bg-black/10";

  return (
    <div data-testid="wisdom-progression" className="grid md:grid-cols-3 gap-px">
      {STEPS.map((s, i) => (
        <Reveal key={s.verb} delay={i * 0.12}>
          <div className="relative px-2 md:px-8 py-6 text-center md:text-left">
            {i > 0 && (
              <span className={`hidden md:block absolute left-0 top-6 bottom-6 w-px ${line}`} />
            )}
            <span className="wk-label">{`0${i + 1} · ${s.verb}`}</span>
            <p className={`mt-4 font-display font-light text-2xl md:text-3xl ${text}`}>
              {s.line}
            </p>
            <p className={`mt-2 text-sm ${sub}`}>{s.note}</p>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
